<template>
  <CDropdown
    placement="bottom-end"
    :caret="false"
    in-nav
    class="c-header-nav-item d-md-down-none mx-2"
    add-menu-classes="pt-0"
    @update:show="viewRecentActions"
  >

    <template #toggler>
      <CHeaderNavLink>
        <CIcon name="cil-bell"/>
          <CBadge v-if="newNotifications > 0" shape="pill" color="danger">{{newNotifications}}</CBadge>
      </CHeaderNavLink>
    </template>

    <CDropdownHeader
      tag="div"
      class="text-center bg-light"
    >
      <strong v-if="newNotifications > 0">{{newNotifications}} Thao tác mới</strong>
      <strong v-else>Thao tác gần đây</strong>
    </CDropdownHeader>

    <CDropdownItem v-for="(notif, index) in notifications" :key="index">
      <CIcon name="cil-history"/>
      {{ notif.action }}
    </CDropdownItem>

    <CDropdownItem class="d-block text-center"
      @click="viewAllActions"
    >
      <strong>Xem tất cả...</strong>
    </CDropdownItem>

    <!-- <CDropdownHeader tag="div" class="text-center bg-light">
      <strong>Trạng thái máy chủ</strong>
    </CDropdownHeader>
    <CDropdownItem class="d-block">
      <div class="text-uppercase mb-1">
        <small><b>CPU Usage</b></small>
      </div>
      <CProgress class="progress-xs" color="info" :value="25"/>
      <small class="text-muted">348 Processes. 1/4 Cores.</small>
    </CDropdownItem>
    <CDropdownItem class="d-block">
      <div class="text-uppercase mb-1">
        <small><b>Memory Usage</b></small>
      </div>
      <CProgress class="progress-xs" color="warning" :value="70"/>
      <small class="text-muted">11444GB/16384MB</small>
    </CDropdownItem>
    <CDropdownItem class="d-block">
      <div class="text-uppercase mb-1">
        <small><b>SSD 1 Usage</b></small>
      </div>
      <CProgress class="progress-xs" color="danger" :value="90"/>
      <small class="text-muted">243GB/256GB</small>
    </CDropdownItem> -->
  </CDropdown>
</template>
<script>
import store from "@/store";

export default {
  name: 'TheHeaderDropdownNotif',
  data () {
    return {
      notifications: [],
      tryGet: false,
      eventSource: null, // SSE connection
      intervalId: null,
    }
  },
  created() {
    this.requestRecentActions()
  },
  mounted() {
    this.intervalId = setInterval(this.backgroundActions, 1000);
    // console.log('create background auto fetch notifications');
  },
  computed: {
    newNotifications () {
      if(this.notifications && this.notifications.length > 0) {
        return this.notifications.filter(item => item.notified === 0).length;
      }
      return 0
    }
  },
  methods: {
    backgroundActions() {
      if (this.$store.state.notiPending) {
        this.requestRecentActions()
        this.$store.state.notiPending = false
        // console.log('set notiPending', this.$store.state.notiPending);
      }
    },
    requestRecentActions () {
      this.$request.get(`/api/actions-recent`).then(res => {
        this.notifications = res.data.actions;
        // console.log('get notifies', this.notifications);
        this.tryGet = true;
      })
    },
    clearRecentActions () {
      this.$request.post(`/api/actions-recent`).then(res => {
        this.notifications = res.data.actions;
        // console.log('post notifies', this.notifications);
      })
    },
    viewRecentActions(value) {
      // console.log('view recent actions', value);
      if (value) {
        if(!this.notifications || !this.notifications.length) {
          this.requestRecentActions()
        }
      } else {
        if (this.tryGet) {
          this.clearRecentActions()
        }
      }
    },
    viewAllActions () {
      if (this.$route.path !== "/actions") {
        this.$router.push("/actions");
      }
    },
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
